import React, { type FC } from 'react';

// Small "PRO" pill shown next to the profile icon for Pro members.
const ProBadge: FC = () => (
  <span
    data-testid="pro-badge"
    className="inline-flex items-center rounded-full bg-indigo-600 px-2 py-0.5 text-xs font-bold tracking-wide text-white"
  >
    PRO
  </span>
);

export default ProBadge;
